// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"8849":"2d597d7880f626b4","25729":"3a7919774a54bb76","28245":"959abaceb1c0986f","69480":"e236917b2ea32c41","79225":"99240e23d476a421","89664":"96ec8e227be278cb"}[chunkId] + ".css";
};